import {React, useContext, useState} from 'external/react'
import {styled, Menu, MenuItem, FormControlLabel, Checkbox, ArrowDropDownIcon}  from 'external/material'
import {TeacherContext} from 'teacher/context'

import create from 'helpers/command'

const StyledHeaderOption = styled('span')(gradeCellOptionStyles)

export default function GradeCellOptions ({column}) {

  const [anchorEl, setAnchorEl] = useState(null)
  const open = Boolean(anchorEl)

  const handleOpenOptions = event => setAnchorEl(event.currentTarget)
  const handleCloseOptions = () => setAnchorEl(null)

  const options = createColumnOptions(column)

  return (
    <StyledHeaderOption>
        <span className="optionsButton" onClick={handleOpenOptions}>
          <ArrowDropDownIcon fontSize="small" />
        </span>
        <Menu
          id="long-menu"
          anchorEl={anchorEl}
          keepMounted
          open={open}
          onClose={handleCloseOptions}
        >
          {options.map(({selected, Option}, index) => (
            <MenuItem key={index} selected={selected} onClick={handleCloseOptions}>
              <Option column={column} />
            </MenuItem>
          ))}
      </Menu>
    </StyledHeaderOption>
  )
}

function createColumnOptions(column) {
  const isExternal = !!column.external
  if (isExternal)
    return [{Option: PublishAllGrades}, {Option: IgnoreGrade}, {Option: DeleteExternalGrade}]
  return [{Option: PublishAllGrades}, {Option: IgnoreGrade}]
}

function PublishAllGrades ({column}) {

  const context = useContext(TeacherContext)
  const {translate, updateState} = context
  const {published = false} = column.properties || {}

  async function handleChange(e) {
    const index = context.rollbookContextGradeColumns.items.findIndex(a => a.id == column.id)
    const published = e.target.checked
    if (index < 0) return
    //updateState({rollbookContextGradeColumns: {items: {[index]: {properties: {published: {$set: published}}}}}})
    const schema = column.external
      ? 'grading'
      : column.type == 'homework'
        ? 'homework'
        : 'quiz'
    await create(schema, 'publishAllGrades')({id: column.id, published})
    
    updateState({rollbookRefresh: {$apply: i => i + 1}})
    //updateState({rollbookContextGradeColumns: {refreshes: {$apply: i => i + 1}}, rollbookContextGrades: {refreshes: {$apply: i => i+1 }}})

  }

  return (<FormControlLabel
    control={<Checkbox color="primary" checked={published} onChange={handleChange} />}
    label={translate(published ? 'grade-published' : 'publish-grade')}
  />)

}

function IgnoreGrade ({column}) {
  const context = useContext(TeacherContext)
  const {translate, updateState} = context
  const {ignore = false} = column.properties || {}

  async function handleChange(e) {

    const index = context.rollbookContextGradeColumns.items.findIndex(a => a.id == column.id)
    const ignore = e.target.checked
    if (index < 0) return

    //updateState({rollbookContextGradeColumns: {items: {[index]: {properties: {ignore: {$set: ignore}}}}}})

    const schema = column.external
      ? 'grading'
      : column.type == 'homework'
        ? 'homework'
        : 'quiz'

    await create(schema, 'ignoreAssignment')({id: column.id, ignore})

    updateState({rollbookRefresh: {$apply: i => i + 1}})
  }

  return (<FormControlLabel
    control={<Checkbox color="primary" checked={ignore} onChange={handleChange} />}
    label={translate('ignore-assessment')}
  />)
}

function DeleteExternalGrade ({column}) {
  const {translate, updateState} = useContext(TeacherContext)
  function handleDelete(e) {
    updateState({
      rollbookContextDeleteGrade: {
          open: {$set: true},
          grade: {$set: column}
        }
    })
  }
  return (<div onClick={handleDelete}>{translate('delete-grade-tooltip')}</div>)
}

function gradeCellOptionStyles() {
  return {
    position: 'absolute',
    top: 0,
    right: 0,
    zIndex: 100,
    color: '#4f576e',
    "& .optionsButton": {
      cursor: 'pointer',
      padding: 2
    },
  }
}
